import type * as Types from '../../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type CashFundPayerFragment = { __typename?: 'CashFundPayer'; email: string; fullName: string; message?: string | null };

export type CashFundPaymentAttemptFragment = {
  __typename?: 'CashFundPaymentAttempt';
  id: string;
  createdAt: string;
  amount: {
    __typename?: 'MonetaryValue';
    valueInMinorUnits: number;
    floatingPointDecimalString: string;
    currency?: { __typename?: 'Currency'; code: string; places: number } | null;
  };
  payer: { __typename?: 'CashFundPayer'; email: string; fullName: string; message?: string | null };
};

export type GetCashFundForContributionQueryVariables = Types.Exact<{
  input: Types.GetCashFundForContributionInput;
}>;

export type GetCashFundForContributionQuery = {
  __typename?: 'Query';
  getCashFundForContribution: {
    __typename?: 'CashFundForContribution';
    cashFund: {
      __typename?: 'CashFund';
      id: string;
      name: string;
      note?: string | null;
      currencyCode: string;
      archived: boolean;
      publicTotalContributedAmount?: {
        __typename?: 'MonetaryValue';
        valueInMinorUnits: number;
        floatingPointDecimalString: string;
        currency?: { __typename?: 'Currency'; code: string; places: number } | null;
      } | null;
      publicTotalGoal?: {
        __typename?: 'MonetaryValue';
        valueInMinorUnits: number;
        floatingPointDecimalString: string;
        currency?: { __typename?: 'Currency'; code: string; places: number } | null;
      } | null;
      fixedContributionAmount?: {
        __typename?: 'MonetaryValue';
        valueInMinorUnits: number;
        floatingPointDecimalString: string;
        currency?: { __typename?: 'Currency'; code: string; places: number } | null;
      } | null;
      photo?: { __typename?: 'Photo'; id: string; url: string } | null;
    };
    host: { __typename?: 'CashFundsHost'; id: string; firstName?: string | null; lastName?: string | null };
    invite?: { __typename?: 'CashFundSolicitationInvite'; id: string; email: string; fullName?: string | null; guestKey?: string | null } | null;
  };
};

export type GetCashFundPaymentAttemptByIdQueryVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;

export type GetCashFundPaymentAttemptByIdQuery = {
  __typename?: 'Query';
  getCashFundPaymentAttemptById: {
    __typename?: 'CashFundPaymentAttempt';
    id: string;
    createdAt: string;
    order: {
      __typename?: 'CashFundOrder';
      id: string;
      status: string;
      contributionAmount: {
        __typename?: 'MonetaryValue';
        valueInMinorUnits: number;
        floatingPointDecimalString: string;
        currency?: { __typename?: 'Currency'; code: string; places: number } | null;
      };
      totalTaxes: {
        __typename?: 'MonetaryValue';
        valueInMinorUnits: number;
        floatingPointDecimalString: string;
        currency?: { __typename?: 'Currency'; code: string; places: number } | null;
      };
      totalFees: {
        __typename?: 'MonetaryValue';
        valueInMinorUnits: number;
        floatingPointDecimalString: string;
        currency?: { __typename?: 'Currency'; code: string; places: number } | null;
      };
      total: {
        __typename?: 'MonetaryValue';
        valueInMinorUnits: number;
        floatingPointDecimalString: string;
        currency?: { __typename?: 'Currency'; code: string; places: number } | null;
      };
    };
    cashFund: {
      __typename?: 'CashFund';
      id: string;
      name: string;
      note?: string | null;
      currencyCode: string;
      archived: boolean;
      publicTotalContributedAmount?: {
        __typename?: 'MonetaryValue';
        valueInMinorUnits: number;
        floatingPointDecimalString: string;
        currency?: { __typename?: 'Currency'; code: string; places: number } | null;
      } | null;
      publicTotalGoal?: {
        __typename?: 'MonetaryValue';
        valueInMinorUnits: number;
        floatingPointDecimalString: string;
        currency?: { __typename?: 'Currency'; code: string; places: number } | null;
      } | null;
      fixedContributionAmount?: {
        __typename?: 'MonetaryValue';
        valueInMinorUnits: number;
        floatingPointDecimalString: string;
        currency?: { __typename?: 'Currency'; code: string; places: number } | null;
      } | null;
      photo?: { __typename?: 'Photo'; id: string; url: string } | null;
    };
    amount: {
      __typename?: 'MonetaryValue';
      valueInMinorUnits: number;
      floatingPointDecimalString: string;
      currency?: { __typename?: 'Currency'; code: string; places: number } | null;
    };
    payer: { __typename?: 'CashFundPayer'; email: string; fullName: string; message?: string | null };
  };
};

export type GetCashFundContributorByIdQueryVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;

export type GetCashFundContributorByIdQuery = {
  __typename?: 'Query';
  getCashFundContributorById: { __typename?: 'CashFundContributor'; id: string; fullName: string; email: string };
};

export type CalculateCashFundContributionReceiptQueryVariables = Types.Exact<{
  input: Types.CalculateCashFundContributionReceiptInput;
}>;

export type CalculateCashFundContributionReceiptQuery = {
  __typename?: 'Query';
  calculateCashFundContributionReceipt: {
    __typename?: 'CashFundContributionReceipt';
    contributionAmount: {
      __typename?: 'MonetaryValue';
      valueInMinorUnits: number;
      floatingPointDecimalString: string;
      currency?: { __typename?: 'Currency'; code: string; places: number } | null;
    };
    fees: Array<{
      __typename?: 'CashFundContributionFee';
      amount: {
        __typename?: 'MonetaryValue';
        valueInMinorUnits: number;
        floatingPointDecimalString: string;
        currency?: { __typename?: 'Currency'; code: string; places: number } | null;
      };
    }>;
    total: {
      __typename?: 'MonetaryValue';
      valueInMinorUnits: number;
      floatingPointDecimalString: string;
      currency?: { __typename?: 'Currency'; code: string; places: number } | null;
    };
    totalFees: {
      __typename?: 'MonetaryValue';
      valueInMinorUnits: number;
      floatingPointDecimalString: string;
      currency?: { __typename?: 'Currency'; code: string; places: number } | null;
    };
  };
};

export type CreateCashFundPaymentIntentMutationVariables = Types.Exact<{
  input: Types.CreateCashFundPaymentIntentInput;
}>;

export type CreateCashFundPaymentIntentMutation = {
  __typename?: 'Mutation';
  createCashFundPaymentIntent:
    | { __typename?: 'CashFundGeneralError'; code: string }
    | { __typename?: 'CashFundPaymentIntent'; id: string; clientSecret: string; paymentAttempt: { __typename?: 'CashFundPaymentAttempt'; id: string } };
};

export type CreateCashFundCheckoutSessionMutationVariables = Types.Exact<{
  input: Types.CreateCashFundCheckoutSessionInput;
}>;

export type CreateCashFundCheckoutSessionMutation = {
  __typename?: 'Mutation';
  createCashFundCheckoutSession: { __typename?: 'CashFundCheckoutSession'; id: string; redirectUrl: string } | { __typename?: 'CashFundGeneralError'; code: string };
};

export const CashFundPayerFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CashFundPayer' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CashFundPayer' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'message' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const CashFundPaymentAttemptFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CashFundPaymentAttempt' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CashFundPaymentAttempt' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'amount' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'MonetaryValue' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'payer' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CashFundPayer' } }] },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CashFundPayer' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CashFundPayer' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'message' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MonetaryValue' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'MonetaryValue' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
          { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'currency' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'places' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const GetCashFundForContributionDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetCashFundForContribution' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'GetCashFundForContributionInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getCashFundForContribution' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cashFund' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PublicCashFund' } }] },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'host' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PublicCashFundsHost' } }] },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'invite' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CashFundInvite' } }] },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MonetaryValue' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'MonetaryValue' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
          { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'currency' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'places' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PublicCashFund' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CashFund' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'note' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currencyCode' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'publicTotalContributedAmount' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'MonetaryValue' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'publicTotalGoal' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'MonetaryValue' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fixedContributionAmount' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'MonetaryValue' } }] },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'photo' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CashFundPhoto' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CashFundPhoto' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Photo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PublicCashFundsHost' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CashFundsHost' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CashFundInvite' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CashFundSolicitationInvite' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'guestKey' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetCashFundForContributionQuery__
 *
 * To run a query within a React component, call `useGetCashFundForContributionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCashFundForContributionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCashFundForContributionQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCashFundForContributionQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCashFundForContributionQuery, GetCashFundForContributionQueryVariables>) {
  return ApolloReactHooks.useQuery<GetCashFundForContributionQuery, GetCashFundForContributionQueryVariables>(GetCashFundForContributionDocument, baseOptions);
}
export function useGetCashFundForContributionLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCashFundForContributionQuery, GetCashFundForContributionQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<GetCashFundForContributionQuery, GetCashFundForContributionQueryVariables>(GetCashFundForContributionDocument, baseOptions);
}
export type GetCashFundForContributionQueryHookResult = ReturnType<typeof useGetCashFundForContributionQuery>;
export type GetCashFundForContributionLazyQueryHookResult = ReturnType<typeof useGetCashFundForContributionLazyQuery>;
export type GetCashFundForContributionQueryResult = Apollo.QueryResult<GetCashFundForContributionQuery, GetCashFundForContributionQueryVariables>;
export const GetCashFundPaymentAttemptByIdDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetCashFundPaymentAttemptById' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getCashFundPaymentAttemptById' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CashFundPaymentAttempt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'order' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CashFundOrder' } }] },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cashFund' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PublicCashFund' } }] },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CashFundPayer' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CashFundPayer' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'message' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CashFundPaymentAttempt' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CashFundPaymentAttempt' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'amount' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'MonetaryValue' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'payer' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CashFundPayer' } }] },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MonetaryValue' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'MonetaryValue' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
          { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'currency' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'places' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PublicCashFund' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CashFund' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'note' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currencyCode' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'publicTotalContributedAmount' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'MonetaryValue' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'publicTotalGoal' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'MonetaryValue' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fixedContributionAmount' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'MonetaryValue' } }] },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'photo' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CashFundPhoto' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CashFundPhoto' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Photo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CashFundOrder' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CashFundOrder' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contributionAmount' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'MonetaryValue' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'totalTaxes' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'MonetaryValue' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'totalFees' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'MonetaryValue' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'total' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'MonetaryValue' } }] },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetCashFundPaymentAttemptByIdQuery__
 *
 * To run a query within a React component, call `useGetCashFundPaymentAttemptByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCashFundPaymentAttemptByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCashFundPaymentAttemptByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCashFundPaymentAttemptByIdQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<GetCashFundPaymentAttemptByIdQuery, GetCashFundPaymentAttemptByIdQueryVariables>,
) {
  return ApolloReactHooks.useQuery<GetCashFundPaymentAttemptByIdQuery, GetCashFundPaymentAttemptByIdQueryVariables>(GetCashFundPaymentAttemptByIdDocument, baseOptions);
}
export function useGetCashFundPaymentAttemptByIdLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCashFundPaymentAttemptByIdQuery, GetCashFundPaymentAttemptByIdQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<GetCashFundPaymentAttemptByIdQuery, GetCashFundPaymentAttemptByIdQueryVariables>(GetCashFundPaymentAttemptByIdDocument, baseOptions);
}
export type GetCashFundPaymentAttemptByIdQueryHookResult = ReturnType<typeof useGetCashFundPaymentAttemptByIdQuery>;
export type GetCashFundPaymentAttemptByIdLazyQueryHookResult = ReturnType<typeof useGetCashFundPaymentAttemptByIdLazyQuery>;
export type GetCashFundPaymentAttemptByIdQueryResult = Apollo.QueryResult<GetCashFundPaymentAttemptByIdQuery, GetCashFundPaymentAttemptByIdQueryVariables>;
export const GetCashFundContributorByIdDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetCashFundContributorById' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getCashFundContributorById' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } } }],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CashFundContributor' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CashFundContributor' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CashFundContributor' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetCashFundContributorByIdQuery__
 *
 * To run a query within a React component, call `useGetCashFundContributorByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCashFundContributorByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCashFundContributorByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCashFundContributorByIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCashFundContributorByIdQuery, GetCashFundContributorByIdQueryVariables>) {
  return ApolloReactHooks.useQuery<GetCashFundContributorByIdQuery, GetCashFundContributorByIdQueryVariables>(GetCashFundContributorByIdDocument, baseOptions);
}
export function useGetCashFundContributorByIdLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCashFundContributorByIdQuery, GetCashFundContributorByIdQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<GetCashFundContributorByIdQuery, GetCashFundContributorByIdQueryVariables>(GetCashFundContributorByIdDocument, baseOptions);
}
export type GetCashFundContributorByIdQueryHookResult = ReturnType<typeof useGetCashFundContributorByIdQuery>;
export type GetCashFundContributorByIdLazyQueryHookResult = ReturnType<typeof useGetCashFundContributorByIdLazyQuery>;
export type GetCashFundContributorByIdQueryResult = Apollo.QueryResult<GetCashFundContributorByIdQuery, GetCashFundContributorByIdQueryVariables>;
export const CalculateCashFundContributionReceiptDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CalculateCashFundContributionReceipt' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'CalculateCashFundContributionReceiptInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'calculateCashFundContributionReceipt' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'contributionAmount' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'MonetaryValue' } }] },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'fees' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'MonetaryValue' } }] },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'total' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'MonetaryValue' } }] },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'totalFees' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'MonetaryValue' } }] },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MonetaryValue' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'MonetaryValue' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
          { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'currency' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'places' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useCalculateCashFundContributionReceiptQuery__
 *
 * To run a query within a React component, call `useCalculateCashFundContributionReceiptQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalculateCashFundContributionReceiptQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalculateCashFundContributionReceiptQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCalculateCashFundContributionReceiptQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<CalculateCashFundContributionReceiptQuery, CalculateCashFundContributionReceiptQueryVariables>,
) {
  return ApolloReactHooks.useQuery<CalculateCashFundContributionReceiptQuery, CalculateCashFundContributionReceiptQueryVariables>(
    CalculateCashFundContributionReceiptDocument,
    baseOptions,
  );
}
export function useCalculateCashFundContributionReceiptLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CalculateCashFundContributionReceiptQuery, CalculateCashFundContributionReceiptQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<CalculateCashFundContributionReceiptQuery, CalculateCashFundContributionReceiptQueryVariables>(
    CalculateCashFundContributionReceiptDocument,
    baseOptions,
  );
}
export type CalculateCashFundContributionReceiptQueryHookResult = ReturnType<typeof useCalculateCashFundContributionReceiptQuery>;
export type CalculateCashFundContributionReceiptLazyQueryHookResult = ReturnType<typeof useCalculateCashFundContributionReceiptLazyQuery>;
export type CalculateCashFundContributionReceiptQueryResult = Apollo.QueryResult<CalculateCashFundContributionReceiptQuery, CalculateCashFundContributionReceiptQueryVariables>;
export const CreateCashFundPaymentIntentDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateCashFundPaymentIntent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateCashFundPaymentIntentInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createCashFundPaymentIntent' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CashFundPaymentIntent' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'clientSecret' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'paymentAttempt' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CashFundGeneralError' } },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'code' } }] },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type CreateCashFundPaymentIntentMutationFn = Apollo.MutationFunction<CreateCashFundPaymentIntentMutation, CreateCashFundPaymentIntentMutationVariables>;

/**
 * __useCreateCashFundPaymentIntentMutation__
 *
 * To run a mutation, you first call `useCreateCashFundPaymentIntentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCashFundPaymentIntentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCashFundPaymentIntentMutation, { data, loading, error }] = useCreateCashFundPaymentIntentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCashFundPaymentIntentMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<CreateCashFundPaymentIntentMutation, CreateCashFundPaymentIntentMutationVariables>,
) {
  return ApolloReactHooks.useMutation<CreateCashFundPaymentIntentMutation, CreateCashFundPaymentIntentMutationVariables>(CreateCashFundPaymentIntentDocument, baseOptions);
}
export type CreateCashFundPaymentIntentMutationHookResult = ReturnType<typeof useCreateCashFundPaymentIntentMutation>;
export type CreateCashFundPaymentIntentMutationResult = Apollo.MutationResult<CreateCashFundPaymentIntentMutation>;
export type CreateCashFundPaymentIntentMutationOptions = Apollo.BaseMutationOptions<CreateCashFundPaymentIntentMutation, CreateCashFundPaymentIntentMutationVariables>;
export const CreateCashFundCheckoutSessionDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateCashFundCheckoutSession' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateCashFundCheckoutSessionInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createCashFundCheckoutSession' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CashFundCheckoutSession' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'redirectUrl' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CashFundGeneralError' } },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'code' } }] },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type CreateCashFundCheckoutSessionMutationFn = Apollo.MutationFunction<CreateCashFundCheckoutSessionMutation, CreateCashFundCheckoutSessionMutationVariables>;

/**
 * __useCreateCashFundCheckoutSessionMutation__
 *
 * To run a mutation, you first call `useCreateCashFundCheckoutSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCashFundCheckoutSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCashFundCheckoutSessionMutation, { data, loading, error }] = useCreateCashFundCheckoutSessionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCashFundCheckoutSessionMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<CreateCashFundCheckoutSessionMutation, CreateCashFundCheckoutSessionMutationVariables>,
) {
  return ApolloReactHooks.useMutation<CreateCashFundCheckoutSessionMutation, CreateCashFundCheckoutSessionMutationVariables>(CreateCashFundCheckoutSessionDocument, baseOptions);
}
export type CreateCashFundCheckoutSessionMutationHookResult = ReturnType<typeof useCreateCashFundCheckoutSessionMutation>;
export type CreateCashFundCheckoutSessionMutationResult = Apollo.MutationResult<CreateCashFundCheckoutSessionMutation>;
export type CreateCashFundCheckoutSessionMutationOptions = Apollo.BaseMutationOptions<CreateCashFundCheckoutSessionMutation, CreateCashFundCheckoutSessionMutationVariables>;
